export type AlertState = {
	show: boolean;
	message: string;
	title: string;
	severity: string;
}

export const alerts : Record<'empty' | 'cannotAllocateCustomerOrders', AlertState> = {
	empty: {
		show: false,
		message: "",
		title: "",
		severity: "",
	},
	cannotAllocateCustomerOrders: {
		show: true,
		message:
			"As this receive has been previously submitted, customer orders have not been re-checked.  If you are receiving additional stock, please check in the Fulfilment App if there are any outstanding customer orders before placing stock on the floor.",
		title: "Cannot allocate customer orders",
		severity: "warning",
	},
};
